import * as types from './mutation-types'
import {Loading} from 'element-ui'
import { setStore, getStore } from '../utils/storage'
import api from '@/api'
export default {
  // 检验登录状态
  [types.CHECKOUT_LOGIN_STATUS](state) {
    state.isLogined = !!window.localStorage.ACCESS_TOKEN
  },
  // Loading 动画
  [types.TOGGLE_LOADING_STATUS](state, quit = false) {
    // 若不进行 加载动画
    if (!quit) {
      state.isLoading = !state.isLoading
      if (state.isLoading) {
        // Loading 为单例
        state.loadingInstance = Loading.service({
          text: '加载中...',
          customClass: 'c-loading'
        })
      }
      // 如果加载已结束，则关闭它
      if (!state.isLoading) {
        if (state.loadingInstance) {
          state.loadingInstance.close()
        }
      }
    }
  },
  [types.TOGGLE_LOADING_STATUS_LOGIN](state, quit = false) {
    // 若不进行 加载动画
    if (!quit) {
      state.isLoading = !state.isLoading
      if (state.isLoading) {
        // Loading 为单例
        state.loadingInstance = Loading.service({
          text: '登陆中,请稍后...',
          customClass: 'c-loading'
        })
      }
      // 如果加载已结束，则关闭它
      if (!state.isLoading) {
        if (state.loadingInstance) {
          state.loadingInstance.close()
        }
      }
    }
  },
  // 用户退出
  [types.USER_LOGOUT](state) {
    // 清除用户的 ACCESS_TOKEN
    window.localStorage.removeItem('ACCESS_TOKEN')
  },

  // 网页初始化时从本地缓存获取购物车数据
  [types.INIT_BUYCART] (state) {
    let initCart = getStore('buyCart')
    if (initCart) {
      let cartList = JSON.parse(initCart)
      state.cartList = cartList
    }
  },
  // 加入购物车
  [types.ADD_CART] (state, {productId, settlementPrice, name, defaultImage, num = 1, specId, specName}) {
    let cart = state.cartList // 购物车
    let falg = true
    let goods = {
      productId,
      settlementPrice,
      name,
      defaultImage,
      specId,
      specName
    }
   
    if (cart.length) {        // 有内容
      cart.forEach(item => {
        if (item.productId === productId && item.specId === specId) {
          if (item.num >= 0) {
            falg = false
            item.num += num
            let p = {
              productId: productId,
              specId: specId,
              num:num
            }
            api.post('api/services/app/FrontendCarts/CreateCarts',p).then(res => {
            })
          }
        }
      })
    }
    if (!cart.length || falg) {
      goods.num = num
      let p = {
        productId: productId,
        specId: specId,
        num:num
      }
       api.post('api/services/app/FrontendCarts/CreateCarts',p).then(res => {
        if(res.data.success){
          cart.push(goods)
        } 
      })
    }
    state.cartList = cart
    // 存入localStorage
    setStore('buyCart', cart)
    //state.showCart = false
  },
  // 加入购物车动画
  [types.ADD_ANIMATION] (state, {moveShow, elLeft, elTop, img, cartPositionT, cartPositionL, receiveInCart}) {
    state.showMoveImg = moveShow
    if (elLeft) {
      state.elLeft = elLeft
      state.elTop = elTop
    }
    state.moveImgUrl = img
    state.receiveInCart = receiveInCart
    if (cartPositionT) {
      state.cartPositionT = cartPositionT
      state.cartPositionL = cartPositionL
    }
  },
  // 是否显示购物车
  [types.SHOW_CART] (state, {showCart}) {
      let timer = null
      state.showCart = showCart
   
     clearTimeout(timer)
     if (showCart) {
       timer = setTimeout(() => {
         //state.showCart = false
       }, 5000)
     }
  },

  // 移除商品
  [types.REDUCE_CART] (state, {productId,specId}) {
    let cart = state.cartList
    cart.forEach((item, i) => {
      if (item.productId === productId && item.specId === specId) {
        let p = {
          productId,
          specId
        }
        api.post('api/services/app/FrontendCarts/ReducingCarts',p).then(res => {
          if(res.data.success){
            cart.splice(i, 1)
          } 
        })
      
      }
    })
    state.cartList = cart
    // 存入localStorage
    setStore('buyCart', state.cartList)
  },
  // 修改购物车
  [types.EDIT_CART] (state, {productId, num, specId}) {
    let cart = state.cartList
   
    if (num) {
      cart.forEach((item, i) => {
        if (item.productId === productId && item.specId === specId) {
          if(num > item.num){
            let addNum = num - item.num
            let p = {
              productId: productId,
              specId: specId,
              num: addNum
            }
            api.post('api/services/app/FrontendCarts/CreateCarts',p)
          }else{
            let addNum = num -item.num
            let p = {
              productId: productId,
              specId: specId,
              num: addNum
            }
             api.post('api/services/app/FrontendCarts/CreateCarts',p)
          }
          item.num = num
        }
      })
    }
    state.cartList = cart
    // 存入localStorage
    setStore('buyCart', state.cartList)
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js